import { get, post } from './httpClient'

export const getLevel = () => get('/level')
export const searchLevel = (object) => get('/level', object)
export const updateLevel = (body) => post('/level/update', body)
export const createLevel = (body) => post('/level/create', body)
